import { c as _c } from "react/compiler-runtime";
export const CheckmarkIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none"><path d="M4.74997 7.64999L2.12497 5.02499C1.83247 4.73249 1.36747 4.73249 1.07497 5.02499C0.782466 5.31749 0.782466 5.78249 1.07497 6.07499L4.21747 9.21749C4.50997 9.50999 4.98247 9.50999 5.27497 9.21749L13.225 1.27499C13.5175 0.98249 13.5175 0.51749 13.225 0.22499C12.9325 -0.0675098 12.4675 -0.0675098 12.175 0.22499L4.74997 7.64999Z" fill="#008254" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};